/**
 * Coordinator for when multiple PILs are possible on page for the same item
 */

let delegateArray: { catRef: string; d: (value: boolean) => void }[] = [];

export function PILregister(
  catalogueRef: string,
  delegate: (value: boolean) => void
) {
  //add our delegates
  delegateArray.push({ catRef: catalogueRef, d: delegate });
}

export function PILunregister() {
  //delete all when unregister is called
  delegateArray = [];
}

export function PILannounce(catalogueRef: string, value: boolean): void {
  for (const delegate of delegateArray.filter(
    (x) => x.catRef == catalogueRef
  )) {
    //announce to all delegates
    delegate.d(value);
  }
}
